// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const CapslockIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="CapslockIcon" ref={forwardedRef} {...props}>
      <path d="M3.496 13.5h13V15h-13z" />
      <path d="M16.364 9.864 10 3.5 3.636 9.864l1.057 1.057L10 5.621l5.303 5.304z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const CapslockIcon = /* @__PURE__ */ Object.assign(
  CapslockIconComponent,
  { displayName: 'CapslockIcon' },
);
